__turbopack_context__.v({
  "className": "roboto_condensed_bb2a811c-module__2mQ3mG__className",
});
